'use es6';

import { createAction } from 'flux-actions';
import { ATTACHMENT_UPLOAD_PROGRESS } from '../constants/fileUploadsActionTypes';
export const attachmentUploadProgress = createAction(ATTACHMENT_UPLOAD_PROGRESS, ({
  localId,
  threadId,
  progress
}) => ({
  localId,
  threadId,
  progress
}));